import type { Transformer as HTMLTagTransformerType, Tag as HTMLTag, Attributes as HTMLAttributes } from 'sanitize-html';
import { observable, attr } from '@microsoft/fast-element';
import type IRWSConfig from './types/IRWSConfig';
import type { NotifyUiType, NotifyLogType } from './types/RWSNotify';
import type { RWSNotify } from './types/RWSNotify';
import RWSService from './services/_service';
import ConfigService, { ConfigServiceInstance } from './services/ConfigService';
import NotifyService, {NotifyServiceInstance} from './services/NotifyService';
import type { DOMOutputType, TagsProcessorType } from './services/DOMService';
import DOMService, { DOMServiceInstance }  from './services/DOMService';
import { sanitizedAttr } from './components/_attrs/sanitize-html';
import { ngAttr } from './components/_attrs/angular-attr';
import { externalObservable } from './components/_attrs/external-observable';
import { externalAttr } from './components/_attrs/external-attr';
import type { DefaultRWSPluginOptionsType } from './plugins/_plugin';
import { RWSPlugin } from './plugins/_plugin';
import type { IRWSPlugin, IStaticRWSPlugin } from './types/IRWSPlugin';
import RWSClient, { RWSClientInstance } from './client';
import type { RWSPluginEntry } from './types/IRWSConfig';
import type IRWSUser from './types/IRWSUser';
import type { IAssetShowOptions } from './components/_component';
import RWSViewComponent from './components/_component';

import RWSContainer from './components/_container';


import type { RWSDecoratorOptions} from './components/_decorator';
import { RWSIgnore, RWSInject, RWSView } from './components/_decorator';

export default RWSClient;
export type { RWSPluginEntry, IRWSPlugin, IStaticRWSPlugin, DefaultRWSPluginOptionsType, NotifyUiType, NotifyLogType, DOMOutputType, RWSNotify, RWSDecoratorOptions as IRWSDecoratorOptions, IAssetShowOptions as IRWSAssetShowOptions, IRWSConfig, IRWSUser, TagsProcessorType, HTMLTagTransformerType, HTMLTag, HTMLAttributes };
export { RWSClient, RWSClientInstance, RWSPlugin, DOMServiceInstance, DOMService, NotifyServiceInstance, NotifyService, ConfigServiceInstance, ConfigService, RWSView, sanitizedAttr, RWSIgnore, RWSInject, observable, externalObservable, externalAttr, attr, ngAttr, RWSService, RWSViewComponent, RWSContainer };